import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';

import {
  Grid
} from '@mui/material';

// import { loginAtom } from '../../lib/auth';

import { Typography } from './Typography';

import SunEditor from 'suneditor-react';
import SunEditorCore from "suneditor/src/lib/core";
import 'suneditor/src/assets/css/suneditor.css'

type StyledEditorNoTranslProps = {
  label: string;
  value: string;
  getSunEditorInstance?: (sunEditor: SunEditorCore) => void;
  onChange: (z:string) => void;
  simple?: boolean;
  advanced?: boolean;
  knowledge?: boolean;
  disabled?: boolean;
  outside_world?: boolean;
  inline?: boolean;
  balloon?: boolean;
  height?: number;
  allowFullScreen?: boolean;
  allowCode?: boolean;
};

export const Editor: FunctionComponent<StyledEditorNoTranslProps> = ({allowFullScreen, outside_world, allowCode, knowledge, disabled, inline, balloon, label, onChange, value, getSunEditorInstance, simple, advanced, height}) => {
  const theme = useTheme();

  // const [login, setLogin] = useAtom(loginAtom);

  const [editorContent, setEditorContent] = useState<string>(value || '');
  const [inited, setInited] = useState<boolean>(false);

  let setting_editor_height = '300px';
  let buttonList = [
    ['undo', 'redo'],
    ['font', 'fontSize', 'formatBlock'],
    ['paragraphStyle', 'blockquote'],
    ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
    ['fontColor', 'hiliteColor', 'textStyle'],
    ['removeFormat'],
    '/',
    ['outdent', 'indent'],
    ['align', 'horizontalRule', 'list', 'lineHeight'],
    ['table', 'link', 'image', 'video'],
    // ['table', 'link', 'image', 'video', 'math'], // You must add the 'katex' library at options to use the 'math' plugin.
    // ['imageGallery'], // You must add the "imageGalleryUrl".
    ['fullScreen', 'showBlocks', 'codeView'],
    ['preview', 'print'],
    // ['save', 'template'],
    // ['dir', 'dir_ltr', 'dir_rtl'],
    // '/', Line break
  ];
  // if (!!login && !!login.extra_data?.settings?.editor_height) setting_editor_height = login.extra_data.settings.editor_height;
  if (!!simple) {
    setting_editor_height = '120px';
    buttonList = [
      ['undo', 'redo'],
      ['bold', 'underline', 'italic', 'strike'],
      ['list', 'outdent', 'indent'],
      ['align'],
      ...(!!allowFullScreen ? [['fullScreen']] : []),
      ...(!!allowCode ? [['codeView']] : [])
    ];
  }
  if (!!advanced) {
    setting_editor_height = '240px';
    buttonList = [
      ['undo', 'redo'],
      ['paragraphStyle', 'formatBlock', 'font', 'fontSize', 'lineHeight'],
      ['bold', 'underline', 'italic', 'strike'],
      ['fontColor', 'hiliteColor', 'removeFormat'],
      // ['fontColor', 'hiliteColor', 'textStyle', 'removeFormat'],
      ['list', 'outdent', 'indent'],
      ['align', 'link', 'image', 'video'],
      ...(!!allowFullScreen ? [['fullScreen']] : []),
      ...(!!allowCode ? [['codeView']] : [])
    ];
  }
  if (!!knowledge) {
    setting_editor_height = '240px';
    buttonList = [
      ['undo', 'redo'],
      // ['paragraphStyle', 'blockquote'],
      ['bold', 'underline', 'italic', 'strike'],
      ['paragraphStyle', 'formatBlock', 'font', 'fontSize', 'formatBlock', 'lineHeight'],
      ['fontColor', 'hiliteColor', 'removeFormat'],
      // ['fontColor', 'hiliteColor', 'textStyle', 'removeFormat'],
      ['list', 'outdent', 'indent'],
      ['align', 'link', 'image'],
      ['fullScreen'],
      ...(!!allowCode ? [['codeView']] : [])
    ];
  }

  setting_editor_height = `100%`;
  if (!!height) {
    setting_editor_height = `${height}px`;
  }

  useEffect(() => {
    if (!inited && value !== editorContent) {
      setEditorContent(value);
      setInited(true);
    }
  }, [value]);

  useEffect(() => {
    if (!!onChange) onChange(editorContent);
  }, [editorContent]);

  return (<>
    <Grid item xs={12} sx={{
      ".se-toolbar-inline": {
        top: '-55px !important',
        width: '600px !important'
      },
      ".se-toolbar-balloon": {
        top: '52px !important',
        width: '600px !important'
      },
      ".sun-editor": {
        ...(!!outside_world ? {
          borderLeft: '12px solid transparent',
          borderRight: '12px solid transparent',
          borderRadius: '0px 18px 0px 18px',
          borderColor: theme.palette.primary.main
        } : {}),
      }
    }}>
      <Typography variant="caption">{label}</Typography>
      {!disabled && <SunEditor
        height={setting_editor_height}
        getSunEditorInstance={getSunEditorInstance}
        setOptions={{
          defaultStyle: "font-size: 16px; font-family: 'Nunito', 'sans-serif'; padding-left: 8px; padding-right: 8px;",
          buttonList: buttonList,
          mode: !!balloon ? 'balloon' : (!!inline ? 'inline' : 'classic'),
        }}
        setContents={editorContent}
        onChange={(v) => {setEditorContent(v);}}
      />}
      {!!disabled && <Typography html sx={{paddingLeft: 2, borderLeft: "5px solid transparent", borderColor: theme.palette.primary.main, "img": { maxWidth: '100%', maxHeight: '300px' }}}>{editorContent}</Typography>}
    </Grid>
  </>);
}